import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Response } from '@shared/interfaces/response/response';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CampoTablaWhereService {
  private _url = environment.apiBaseUrl + 'api/parimetria/campotablawhere/';

  constructor(private _http: HttpClient) {}

  empresas(): Observable<Response> {
    return this._http.get<Response>(this._url + 'empresas/');
  }

  monedas(): Observable<Response> {
    return this._http.get<Response>(this._url + 'monedas/');
  }

  sucursales(empresa: string): Observable<Response> {
    var url = this._url + 'sucursales/' + empresa;
    return this._http.get<Response>(url);
  }

  catalogo(): Observable<Response> {
    var url = environment.apiBaseUrl + 'api/campodetablawhere';
    return this._http.get<Response>(url);
  }
}
